import { __assign, __rest } from "tslib";
import React from 'react';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltCommentDialogOptionsDropdownContentMarkAsReadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-mark-as-read-wireframe", __assign({}, transformedProps), children));
};
export default VeltCommentDialogOptionsDropdownContentMarkAsReadWireframe;
